import { createContext, useContext } from 'react';
import { useForm } from './form-context';
export const PanoramaContext = /*#__PURE__*/createContext(undefined);
export function usePanorama() {
  const context = useContext(PanoramaContext);
  if (context === undefined) {
    throw new Error('usePanorama must be used within a PanoramaProvider');
  }
  const panorama = context.panorama;
  const {
    namespace
  } = useForm();
  return {
    transaction: name => ({
      start: () => panorama == null ? void 0 : panorama.transaction(name).start({
        namespace
      }),
      finish: () => panorama == null ? void 0 : panorama.transaction(name).finish({
        namespace
      })
    })
  };
}
//# sourceMappingURL=panorama-context.js.map